import React, { useState, useRef, useEffect, useCallback } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Select from 'react-select';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/**
 * Map static-content `/searchCityAirport/v2` (or allAirports) rows
 * into the shared option shape used by GiGi B2B + B2C.
 *
 * Host owns HTTP; this only normalizes the payload.
 *
 * Hierarchy: v2 may already send isChild/parentCode. Full-list
 * allAirports does not — derive from type=city + otherAirportCodes
 * (e.g. CDG.otherAirportCodes = ['PAR']).
 */

/** Postgres may send text[], JSON, "{YTO}", or "YTO,YTZ". */
function parseAirportCodeList(value) {
  if (value == null || value === '') {
    return [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(function (item) {
      return parseAirportCodeList(item);
    }).filter(Boolean);
  }
  var raw = String(value).trim();
  if (!raw || raw === 'null' || raw === '[]' || raw === '{}') {
    return [];
  }
  if (raw.startsWith('[')) {
    try {
      return parseAirportCodeList(JSON.parse(raw));
    } catch (_unused) {
      // fall through to delimiter split
    }
  }
  return raw.replace(/^[{\[]|[}\]]$/g, '').split(/[,;|]/).map(function (code) {
    return code.replace(/^["']|["']$/g, '').trim().toUpperCase();
  }).filter(function (code) {
    return /^[A-Z0-9]{3,4}$/.test(code);
  });
}
function isCityType(element) {
  return String((element === null || element === void 0 ? void 0 : element.type) || '').toLowerCase() === 'city';
}
function isMetroRecord(element) {
  return isCityType(element) || /all\s*airports/i.test(String((element === null || element === void 0 ? void 0 : element.name) || ''));
}

/** Child airports point at a metro (YYZ → YTO). City rows may list children. */
function deriveAirportParentCode(element) {
  if (!element) return null;
  if (element.parentCode) {
    return String(element.parentCode).toUpperCase();
  }
  if (isCityType(element)) {
    return null;
  }
  var codes = parseAirportCodeList(element.otherAirportCodes);
  return codes[0] || null;
}
function countryCode(option) {
  var value = (option === null || option === void 0 ? void 0 : option.value) || {};
  return String(value.countrycode || value.country_code || '').toUpperCase();
}
function sortRankBucket(matches) {
  return _toConsumableArray(matches).sort(function (a, b) {
    var _a$value, _b$value;
    var countryA = countryCode(a);
    var countryB = countryCode(b);
    if (countryA !== countryB) {
      return countryA.localeCompare(countryB);
    }
    return String(((_a$value = a.value) === null || _a$value === void 0 ? void 0 : _a$value.code) || '').localeCompare(String(((_b$value = b.value) === null || _b$value === void 0 ? void 0 : _b$value.code) || ''));
  });
}

/** Mirrors static-content buildGroupedAirportSuggest matchRank. */
function matchRankOption(option, str) {
  var value = (option === null || option === void 0 ? void 0 : option.value) || {};
  var code = String(value.code || '').toUpperCase();
  var city = String(value.city || '').toUpperCase();
  var name = String(value.name || '').toUpperCase();
  var location = String(value.location || '').toUpperCase();
  if (code.startsWith(str)) {
    return 1;
  }
  if (city.startsWith(str) || location.startsWith(str)) {
    return 2;
  }
  if (name.startsWith(str)) {
    return 3;
  }
  if (name.includes(str) || city.includes(str) || location.includes(str)) {
    return 4;
  }
  return null;
}
function mapSearchCityAirportResponse(result) {
  if (!result) {
    return [];
  }
  var rows = Array.isArray(result) ? result : Array.isArray(result.airports) ? result.airports : [];
  return rows.map(function (element) {
    var derivedParent = deriveAirportParentCode(element);
    var isChild = element.isChild === true || element.isChild === 'true' || Boolean(derivedParent && !isCityType(element));
    return {
      value: element,
      label: "".concat(element.code, " - ").concat(element.name),
      customAbbreviation: element.location,
      isChild: Boolean(isChild),
      parentCode: isChild ? derivedParent : null
    };
  });
}

/** Unique option identity when the same IATA can appear as parent + child. */
function getAirportSuggestOptionValue(option) {
  var _option$value;
  var code = (option === null || option === void 0 || (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.code) || '';
  var kind = option !== null && option !== void 0 && option.isChild ? 'child' : 'main';
  var parent = (option === null || option === void 0 ? void 0 : option.parentCode) || '';
  return "".concat(code, "-").concat(kind, "-").concat(parent);
}

/**
 * MUI Autocomplete filter that preserves API rank/grouping.
 * Do not client-refilter away parent → child order from v2.
 */
function preserveApiOrderFilter(options, state) {
  if (!options || options.length === 0) {
    return [];
  }
  var term = ((state === null || state === void 0 ? void 0 : state.inputValue) || '').trim();
  if (!term) {
    return [];
  }
  return options;
}

/**
 * Place metro parents first, each followed by their child airports.
 * Pulls missing parents/children from the full list when needed.
 */
function groupAirportSuggestOptions(matches, allOptions) {
  var maxResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  if (!(matches !== null && matches !== void 0 && matches.length)) {
    return [];
  }
  var byCode = new Map();
  var _iterator = _createForOfIteratorHelper(allOptions || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _option4$value;
      var _option4 = _step.value;
      var _code = _option4 === null || _option4 === void 0 || (_option4$value = _option4.value) === null || _option4$value === void 0 || (_option4$value = _option4$value.code) === null || _option4$value === void 0 ? void 0 : _option4$value.toUpperCase();
      if (!_code) continue;
      var existing = byCode.get(_code);
      // Prefer non-child (metro/main) row when the same code appears twice.
      if (!existing || existing.isChild && !_option4.isChild) {
        byCode.set(_code, _option4);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var selected = new Map();
  var add = function add(option) {
    if (!option) return;
    selected.set(getAirportSuggestOptionValue(option), option);
  };
  matches.forEach(add);

  // Ensure parents of matched children are present.
  for (var _i = 0, _arr = _toConsumableArray(selected.values()); _i < _arr.length; _i++) {
    var option = _arr[_i];
    if (!option.isChild || !option.parentCode) continue;
    add(byCode.get(String(option.parentCode).toUpperCase()));
  }

  // Attach full-list children under any selected parent/metro.
  var parentCodes = new Set();
  var _iterator2 = _createForOfIteratorHelper(selected.values()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _option5$value;
      var _option5 = _step2.value;
      if (_option5.isChild) continue;
      var _code2 = _option5 === null || _option5 === void 0 || (_option5$value = _option5.value) === null || _option5$value === void 0 || (_option5$value = _option5$value.code) === null || _option5$value === void 0 ? void 0 : _option5$value.toUpperCase();
      if (_code2) parentCodes.add(_code2);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(allOptions || []),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _option6 = _step3.value;
      if (!(_option6 !== null && _option6 !== void 0 && _option6.isChild) || !_option6.parentCode) continue;
      if (parentCodes.has(String(_option6.parentCode).toUpperCase())) {
        add(_option6);
      }
    }

    // City metros may list child IATA codes in otherAirportCodes.
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  for (var _i2 = 0, _arr2 = _toConsumableArray(selected.values()); _i2 < _arr2.length; _i2++) {
    var _option$value2;
    var _option = _arr2[_i2];
    if (_option.isChild || !isCityType(_option === null || _option === void 0 ? void 0 : _option.value)) continue;
    var _iterator4 = _createForOfIteratorHelper(parseAirportCodeList(_option === null || _option === void 0 || (_option$value2 = _option.value) === null || _option$value2 === void 0 ? void 0 : _option$value2.otherAirportCodes)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var code = _step4.value;
        add(byCode.get(code));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  var combined = [];
  var seen = new Set();
  var push = function push(option) {
    if (!option || combined.length >= maxResults) return;
    var key = getAirportSuggestOptionValue(option);
    if (seen.has(key)) return;
    seen.add(key);
    combined.push(option);
  };
  var parents = [];
  var looseChildren = [];
  var _iterator5 = _createForOfIteratorHelper(selected.values()),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _option7 = _step5.value;
      if (_option7.isChild) {
        looseChildren.push(_option7);
      } else {
        parents.push(_option7);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  for (var _i3 = 0, _parents = parents; _i3 < _parents.length; _i3++) {
    var _parent$value;
    var parent = _parents[_i3];
    push(parent);
    var parentCode = String((parent === null || parent === void 0 || (_parent$value = parent.value) === null || _parent$value === void 0 ? void 0 : _parent$value.code) || '').toUpperCase();
    var _iterator6 = _createForOfIteratorHelper(selected.values()),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _option2 = _step6.value;
        if (_option2.isChild && String(_option2.parentCode || '').toUpperCase() === parentCode) {
          push(_option2);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  for (var _i4 = 0, _looseChildren = looseChildren; _i4 < _looseChildren.length; _i4++) {
    var _option3 = _looseChildren[_i4];
    push(_option3);
  }
  return combined;
}

/**
 * Only keep the child arrow when the parent metro is also in the list.
 * Exact-code / v2 responses often return CDG alone with isChild=true —
 * without PAR that arrow looks wrong on a "main" row.
 */
function normalizeAirportSuggestChildMarkers(options) {
  if (!(options !== null && options !== void 0 && options.length)) {
    return [];
  }
  var codes = new Set(options.map(function (option) {
    var _option$value3;
    return option === null || option === void 0 || (_option$value3 = option.value) === null || _option$value3 === void 0 || (_option$value3 = _option$value3.code) === null || _option$value3 === void 0 ? void 0 : _option$value3.toUpperCase();
  }).filter(Boolean));
  return options.map(function (option) {
    var parent = option !== null && option !== void 0 && option.parentCode ? String(option.parentCode).toUpperCase() : null;
    // Arrow is only meaningful when the parent metro is also visible.
    if (option !== null && option !== void 0 && option.isChild && (!parent || !codes.has(parent))) {
      return _objectSpread2(_objectSpread2({}, option), {}, {
        isChild: false
      });
    }
    return option;
  });
}
function mergeGroupedOptions(groups, maxResults) {
  var combined = [];
  var seen = new Set();
  var _iterator7 = _createForOfIteratorHelper(groups),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var group = _step7.value;
      var _iterator8 = _createForOfIteratorHelper(group || []),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var option = _step8.value;
          var key = getAirportSuggestOptionValue(option);
          if (seen.has(key)) continue;
          seen.add(key);
          combined.push(option);
          if (combined.length >= maxResults) {
            return combined;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return combined;
}

/**
 * Local filter matching static-content `/searchCityAirport/v2` processData,
 * then regroup into parent → child hierarchy for the UI.
 *
 * Matches city, name, location, and IATA. Exact IATA stays first so
 * "ORD" is not crowded out by city substrings like Oxford / Concord.
 *
 * @param {Array} allOptions
 * @param {string} query
 * @param {{ maxResults?: number }} [opts]
 */
function filterAirportSuggestOptions(allOptions, query) {
  var _opts$maxResults;
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var maxResults = (_opts$maxResults = opts.maxResults) !== null && _opts$maxResults !== void 0 ? _opts$maxResults : 50;
  var str = (query || '').trim().toUpperCase();
  if (!str || !Array.isArray(allOptions) || allOptions.length === 0) {
    return [];
  }
  var exact = [];
  var rankBuckets = [[], [], [], []];
  var _iterator9 = _createForOfIteratorHelper(allOptions),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _option$value4;
      var option = _step9.value;
      var code = option === null || option === void 0 || (_option$value4 = option.value) === null || _option$value4 === void 0 || (_option$value4 = _option$value4.code) === null || _option$value4 === void 0 ? void 0 : _option$value4.toUpperCase();
      if (code && code === str) {
        exact.push(option);
        continue;
      }
      var rank = matchRankOption(option, str);
      if (rank != null) {
        rankBuckets[rank - 1].push(option);
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  var groups = [];
  var remaining = maxResults;
  var pushGroup = function pushGroup(matches) {
    if (remaining <= 0 || !matches.length) return;
    var grouped = groupAirportSuggestOptions(sortRankBucket(matches), allOptions, remaining);
    if (grouped.length) {
      groups.push(grouped);
      remaining -= grouped.length;
    }
  };
  if (exact.length && exact.every(function (option) {
    return !isMetroRecord(option === null || option === void 0 ? void 0 : option.value);
  })) {
    return normalizeAirportSuggestChildMarkers(sortRankBucket(exact).map(function (option) {
      return _objectSpread2(_objectSpread2({}, option), {}, {
        isChild: false,
        parentCode: null
      });
    }));
  }
  if (exact.length) {
    pushGroup(exact);
  }
  for (var _i5 = 0, _rankBuckets = rankBuckets; _i5 < _rankBuckets.length; _i5++) {
    var bucket = _rankBuckets[_i5];
    pushGroup(bucket);
  }
  return normalizeAirportSuggestChildMarkers(mergeGroupedOptions(groups, maxResults));
}

/**
 * In-memory airport suggest cache shared across mounts.
 * Host injects HTTP only. Filtering, grouping, and child-arrow
 * rules live in this package.
 */

/** Bump when mapped option shape / hierarchy rules change. */
var CACHE_VERSION = 3;
var cachedOptions = null;
var inflight = null;
var loadedAt = null;
var cacheVersion = null;
function hierarchyLooksStale(options) {
  if (!Array.isArray(options) || !options.length) return true;
  // Children should be marked isChild when otherAirportCodes points at a metro.
  return options.some(function (option) {
    var _option$value, _option$value2;
    var other = option === null || option === void 0 || (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.otherAirportCodes;
    var isCity = String((option === null || option === void 0 || (_option$value2 = option.value) === null || _option$value2 === void 0 ? void 0 : _option$value2.type) || '').toLowerCase() === 'city';
    return Array.isArray(other) && other.length > 0 && !isCity && option.isChild !== true;
  });
}
function getCachedAirportSuggestOptions() {
  return cachedOptions;
}
function isAirportSuggestCacheReady() {
  return Array.isArray(cachedOptions) && cachedOptions.length > 0;
}
function getAirportSuggestCacheLoadedAt() {
  return loadedAt;
}
function clearAirportSuggestCache() {
  cachedOptions = null;
  loadedAt = null;
  inflight = null;
  cacheVersion = null;
}

/**
 * @param {() => Promise<any[]>} fetchAllMapped
 * @returns {Promise<any[]>}
 */
function ensureAirportSuggestOptions(fetchAllMapped) {
  if (cacheVersion !== CACHE_VERSION || hierarchyLooksStale(cachedOptions)) {
    cachedOptions = null;
    loadedAt = null;
    // keep inflight if a fetch is already in progress for this version
    if (cacheVersion !== CACHE_VERSION) {
      inflight = null;
    }
  }
  if (Array.isArray(cachedOptions) && cachedOptions.length > 0) {
    return Promise.resolve(cachedOptions);
  }
  if (inflight) {
    return inflight;
  }
  if (typeof fetchAllMapped !== 'function') {
    return Promise.reject(new Error('fetchAllMapped is required'));
  }
  inflight = Promise.resolve().then(function () {
    return fetchAllMapped();
  }).then(function (list) {
    var next = Array.isArray(list) ? list : [];
    // If host somehow returned raw rows, normalize.
    if (next.length && next[0] && next[0].value == null && next[0].code) {
      next = mapSearchCityAirportResponse(next);
    }
    cachedOptions = next;
    loadedAt = Date.now();
    cacheVersion = CACHE_VERSION;
    inflight = null;
    return cachedOptions;
  }).catch(function (err) {
    inflight = null;
    throw err;
  });
  return inflight;
}

/**
 * Sync filter against cache. Returns null if cache is not ready
 * (caller should fall back to remote suggest).
 *
 * @param {string} query
 * @param {{ maxResults?: number }} [opts]
 * @returns {any[] | null}
 */
function suggestAirportsFromCache(query) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!isAirportSuggestCacheReady() || hierarchyLooksStale(cachedOptions)) {
    return null;
  }
  return filterAirportSuggestOptions(cachedOptions, query, opts);
}

/**
 * Group + child-arrow rules for already-mapped options.
 * Used when serving a remote v2 payload through the same pipeline.
 */
function finalizeAirportSuggestOptions(mapped) {
  var rows = Array.isArray(mapped) ? mapped : [];
  var all = getCachedAirportSuggestOptions();
  if (all !== null && all !== void 0 && all.length) {
    return normalizeAirportSuggestChildMarkers(groupAirportSuggestOptions(rows, all));
  }
  return normalizeAirportSuggestChildMarkers(rows);
}

/**
 * Typed-suggest entry point. Hosts inject HTTP; this package owns
 * cache lookup, v2 fallback mapping, metro grouping, and arrows.
 *
 * @param {string} query
 * @param {{
 *   fetchAllMapped?: () => Promise<any[]>,
 *   fetchRemote?: (query: string) => Promise<any>,
 *   maxResults?: number,
 * }} [io]
 * @returns {Promise<any[]>}
 */
function searchAirportSuggest(_x) {
  return _searchAirportSuggest.apply(this, arguments);
}
function _searchAirportSuggest() {
  _searchAirportSuggest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
    var io,
      local,
      remote,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          io = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          local = suggestAirportsFromCache(query, {
            maxResults: io.maxResults
          });
          if (!local) {
            _context.n = 1;
            break;
          }
          return _context.a(2, local);
        case 1:
          if (typeof io.fetchAllMapped === 'function') {
            ensureAirportSuggestOptions(io.fetchAllMapped).catch(function () {});
          }
          if (!(typeof io.fetchRemote !== 'function')) {
            _context.n = 2;
            break;
          }
          return _context.a(2, []);
        case 2:
          _context.n = 3;
          return io.fetchRemote(query);
        case 3:
          remote = _context.v;
          return _context.a(2, finalizeAirportSuggestOptions(mapSearchCityAirportResponse(remote)));
      }
    }, _callee);
  }));
  return _searchAirportSuggest.apply(this, arguments);
}

/**
 * Shared option label for react-select (B2B) or any host that wants the
 * nested child affordance without owning the markup.
 */
function formatAirportSuggestOptionLabel(_ref) {
  var label = _ref.label,
    customAbbreviation = _ref.customAbbreviation,
    isChild = _ref.isChild;
  return /*#__PURE__*/React.createElement("div", {
    className: "airport-suggest-option"
  }, isChild ? /*#__PURE__*/React.createElement("span", {
    className: "airport-suggest-option__child-marker",
    "aria-hidden": "true"
  }, "\u21B3") : null, /*#__PURE__*/React.createElement("div", {
    className: "airport-suggest-option__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "airport-suggest-option__label"
  }, label), customAbbreviation ? /*#__PURE__*/React.createElement("div", {
    className: "airport-suggest-option__subtitle"
  }, customAbbreviation) : null));
}

/** Inline styles equivalent for hosts that do not load package CSS. */
function getChildOptionStyle() {
  var baseStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _objectSpread2(_objectSpread2({}, baseStyles), {}, {
    whiteSpace: 'normal',
    paddingLeft: isChild ? 20 : baseStyles.paddingLeft
  });
}

var _excluded$1 = ["id", "className", "options", "inputValue", "value", "onInputChange", "onChange", "onBlur", "placeholder", "disablePortal", "freeSolo", "disabled", "error", "helperText", "disableClearable", "renderInput", "startAdornment"],
  _excluded2 = ["key"];

/**
 * Presentational MUI airport autosuggest for B2C (and any MUI host).
 * Host owns options + fetch/debounce and selection state.
 *
 * Controlled props:
 * - options, inputValue, onInputChange, value, onChange
 */
function AirportAutosuggest(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'airport-autosuggest' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$inputValue = _ref.inputValue,
    inputValue = _ref$inputValue === void 0 ? '' : _ref$inputValue,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _onInputChange = _ref.onInputChange,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Enter City or Airport' : _ref$placeholder,
    _ref$disablePortal = _ref.disablePortal,
    disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
    _ref$freeSolo = _ref.freeSolo,
    freeSolo = _ref$freeSolo === void 0 ? true : _ref$freeSolo,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? '' : _ref$helperText,
    disableClearable = _ref.disableClearable,
    renderInput = _ref.renderInput,
    startAdornment = _ref.startAdornment,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement(Autocomplete, _extends({
    id: id,
    className: "airport-autosuggest ".concat(className).trim(),
    options: options,
    value: value,
    inputValue: inputValue,
    freeSolo: freeSolo,
    disabled: disabled,
    disablePortal: disablePortal,
    disableClearable: typeof disableClearable === 'boolean' ? disableClearable : !inputValue,
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === 'string' ? option : (option === null || option === void 0 ? void 0 : option.label) || '';
    },
    isOptionEqualToValue: function isOptionEqualToValue(option, selected) {
      return getAirportSuggestOptionValue(option) === getAirportSuggestOptionValue(selected);
    },
    onChange: function onChange(event, data) {
      if (_onChange) {
        _onChange(event, data);
      }
    },
    onInputChange: function onInputChange(event, next, reason) {
      if (_onInputChange) {
        _onInputChange(event, next, reason);
      }
    },
    onBlur: onBlur,
    renderOption: function renderOption(props, option) {
      var _optionProps$style;
      var key = props.key,
        optionProps = _objectWithoutProperties(props, _excluded2);
      return /*#__PURE__*/React.createElement("li", _extends({
        key: key || getAirportSuggestOptionValue(option)
      }, optionProps, {
        className: "".concat(optionProps.className || '', " airport-suggest-option ").concat(option !== null && option !== void 0 && option.isChild ? 'rightArrow airport-suggest-option--child' : '').trim(),
        style: _objectSpread2(_objectSpread2({}, optionProps.style || {}), {}, {
          alignItems: 'flex-start',
          whiteSpace: 'normal',
          height: 'auto',
          minHeight: 48,
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: option !== null && option !== void 0 && option.isChild ? 28 : (_optionProps$style = optionProps.style) === null || _optionProps$style === void 0 ? void 0 : _optionProps$style.paddingLeft
        })
      }), /*#__PURE__*/React.createElement("div", {
        className: "airport-suggest-option__content"
      }, /*#__PURE__*/React.createElement("span", {
        className: "airport-suggest-option__label"
      }, option !== null && option !== void 0 && option.isChild ? '↳ ' : '', option.label), option.customAbbreviation ? /*#__PURE__*/React.createElement("span", {
        className: "airport-suggest-option__subtitle"
      }, option.customAbbreviation) : null));
    },
    renderInput: renderInput || function (params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: placeholder,
        error: error,
        helperText: helperText,
        InputProps: _objectSpread2(_objectSpread2({}, params.InputProps), startAdornment ? {
          startAdornment: startAdornment
        } : {})
      }));
    }
  }, rest, {
    filterOptions: preserveApiOrderFilter
  }));
}

var _excluded = ["options", "value", "onChange", "onInputChange", "placeholder", "className", "classNamePrefix", "name", "isClearable", "isDisabled", "styles", "components", "filterOption"];
var Hidden = function Hidden() {
  return null;
};

/**
 * Drop-in react-select airport field for GiGi B2B.
 * Host owns options fetch/debounce and selection state.
 */
function AirportSelect(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    onChange = _ref.onChange,
    onInputChange = _ref.onInputChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Flying From' : _ref$placeholder,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'form-control flying-input' : _ref$className,
    _ref$classNamePrefix = _ref.classNamePrefix,
    classNamePrefix = _ref$classNamePrefix === void 0 ? 'select' : _ref$classNamePrefix,
    name = _ref.name,
    _ref$isClearable = _ref.isClearable,
    isClearable = _ref$isClearable === void 0 ? true : _ref$isClearable,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    stylesProp = _ref.styles,
    componentsProp = _ref.components,
    _ref$filterOption = _ref.filterOption,
    filterOption = _ref$filterOption === void 0 ? function () {
      return true;
    } : _ref$filterOption,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = _objectSpread2({
    option: function option(base, state) {
      var _state$data;
      return getChildOptionStyle(base, Boolean((_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.isChild));
    }
  }, stylesProp || {});
  var formatOptionLabel = function formatOptionLabel(data, meta) {
    return (meta === null || meta === void 0 ? void 0 : meta.context) === 'menu' ? formatAirportSuggestOptionLabel(data) : (data === null || data === void 0 ? void 0 : data.label) || '';
  };
  return /*#__PURE__*/React.createElement(Select, _extends({
    name: name,
    className: className,
    classNamePrefix: classNamePrefix,
    styles: styles,
    value: value,
    options: options,
    placeholder: placeholder,
    isClearable: isClearable,
    isDisabled: isDisabled,
    onChange: onChange,
    onInputChange: onInputChange,
    formatOptionLabel: formatOptionLabel,
    getOptionValue: getAirportSuggestOptionValue,
    components: _objectSpread2({
      DropdownIndicator: Hidden,
      IndicatorSeparator: Hidden,
      NoOptionsMessage: Hidden
    }, componentsProp || {})
  }, rest, {
    filterOption: filterOption
  }));
}

/**
 * Host injects `fetchAirports(query)` that returns mapped options
 * (or raw rows — host may map before return). Package only debounces.
 *
 * @param {(query: string) => Promise<any[]>} fetchAirports
 * @param {{ delayMs?: number }} [options]
 */
function useDebouncedAirportSuggest(fetchAirports) {
  var _options$delayMs;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var delayMs = (_options$delayMs = options.delayMs) !== null && _options$delayMs !== void 0 ? _options$delayMs : 500;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var timerRef = useRef(null);
  var fetchRef = useRef(fetchAirports);
  useEffect(function () {
    fetchRef.current = fetchAirports;
  }, [fetchAirports]);
  var runFetch = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
      var trimmed, next, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trimmed = (value || '').trim();
            if (!(!trimmed || !/^[a-z0-9\s]+$/i.test(trimmed))) {
              _context.n = 1;
              break;
            }
            setItems([]);
            setLoading(false);
            return _context.a(2);
          case 1:
            setLoading(true);
            setError(null);
            _context.p = 2;
            _context.n = 3;
            return fetchRef.current(trimmed);
          case 3:
            next = _context.v;
            setItems(Array.isArray(next) ? next : []);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setError(_t);
            setItems([]);
          case 5:
            _context.p = 5;
            setLoading(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var onQueryChange = useCallback(function (value) {
    setQuery(value);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(function () {
      runFetch(value);
    }, delayMs);
  }, [delayMs, runFetch]);
  useEffect(function () {
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  return {
    query: query,
    setQuery: setQuery,
    items: items,
    loading: loading,
    error: error,
    onQueryChange: onQueryChange,
    refetch: runFetch
  };
}

export { AirportAutosuggest, AirportSelect, clearAirportSuggestCache, ensureAirportSuggestOptions, filterAirportSuggestOptions, finalizeAirportSuggestOptions, formatAirportSuggestOptionLabel, getAirportSuggestCacheLoadedAt, getAirportSuggestOptionValue, getCachedAirportSuggestOptions, getChildOptionStyle, groupAirportSuggestOptions, isAirportSuggestCacheReady, mapSearchCityAirportResponse, normalizeAirportSuggestChildMarkers, preserveApiOrderFilter, searchAirportSuggest, suggestAirportsFromCache, useDebouncedAirportSuggest };
//# sourceMappingURL=index.es.js.map
